import { TZDate } from "@date-fns/tz";

/** Fachliche Zeitzone aller Läden (Plan 2: speichern UTC, anzeigen Europe/Berlin). */
export const ZEITZONE = "Europe/Berlin";

export function jetztIso(): string {
  return new Date().toISOString();
}

/** Kalendertag `YYYY-MM-DD` in Europe/Berlin für einen Zeitpunkt. */
export function tagVon(zeitpunkt: Date | string | number = Date.now()): string {
  const d = new TZDate(new Date(zeitpunkt).getTime(), ZEITZONE);
  const m = (d.getMonth() + 1).toString().padStart(2, "0");
  const t = d.getDate().toString().padStart(2, "0");
  return `${d.getFullYear()}-${m}-${t}`;
}

/** `15.10.2026` (wie Regal.formatDate). */
export function formatDatum(zeitpunkt: Date | string | number): string {
  const d = new Date(zeitpunkt);
  return new Intl.DateTimeFormat("de-DE", { timeZone: ZEITZONE, day: "2-digit", month: "2-digit", year: "numeric" }).format(d);
}

/** `14:32` bzw. mit Sekunden `14:32:08`. */
export function formatUhrzeit(zeitpunkt: Date | string | number, sekunden = false): string {
  const d = new Date(zeitpunkt);
  return new Intl.DateTimeFormat("de-DE", {
    timeZone: ZEITZONE,
    hour: "2-digit",
    minute: "2-digit",
    ...(sekunden ? { second: "2-digit" } : {}),
  }).format(d);
}

/** `15.10.2026, 14:32`. */
export function formatDatumZeit(zeitpunkt: Date | string | number): string {
  return `${formatDatum(zeitpunkt)}, ${formatUhrzeit(zeitpunkt)}`;
}

export function plusMinuten(iso: string, minuten: number): string {
  return new Date(new Date(iso).getTime() + minuten * 60_000).toISOString();
}

/** Kalendertag `YYYY-MM-DD` formatieren → `15.10.2026`. */
export function formatTag(tag: string): string {
  const [j, m, t] = tag.split("-");
  return `${t}.${m}.${j}`;
}
